export enum LoadTruck {
            load = 'load',
            truck = 'truck'
}
